import { render, staticRenderFns } from "./MessagesLive.vue?vue&type=template&id=359ae1f4&"
import script from "./MessagesLive.vue?vue&type=script&lang=ts&"
export * from "./MessagesLive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports